import React from "react";

import { exportP2PInLegConfig } from "constants/p2pLeg/containerConfig";

import { NLISP2PLegFileTab } from "./NLISP2PLegFileTab";

export const NLISExportP2PInFileInfo = () => (
  <NLISP2PLegFileTab config={exportP2PInLegConfig} />
);
